<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color" (click)="whatsApp()">Quick Help</div>
      <div class="big-caption text-default-color" style="padding: 20px">
        If you need help with something else,here's what you can do
      </div>
    </div>
  </div>

  <div class="quick-help container row d-flexbox flex-wrap">
    <div class="img-card" data-aos="zoom-in" data-aos-duration="2000">
      <img src="../../../../assets/img/c-1.jpeg" alt="" />
      <div class="overlay">
        <div
          class="content d-flexbox col justify-content-left align-items-left"
        >
          <h3 class="text-align-left" style="color: #fff; position: relative">
            Already a HuiosPay merchant <br />
            but need some assistance?
          </h3>
          <div class="btn outlined" style="margin: unset" (click)="paymentGateway()">
            Login to your account
          </div>
        </div>
      </div>
    </div>
    <div class="img-card" data-aos="zoom-in" data-aos-duration="2000">
      <img src="../../../../assets/img/paying.png" alt="" />
      <div class="overlay">
        <div
          class="content d-flexbox col justify-content-left align-items-left"
        >
          <h3 class="small-caption text-align-left" style="color: #fff">
            New to HuiosPay and need <br />
            assistance with our services?
          </h3>
          <div class="btn outlined" style="margin: unset" (click)="whatsApp()">
            Speak to our Virtual Assistant
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-wrapper d-flexbox col">
    <h2>You can also send us a request</h2>
    <form
      class="form d-flexbox col justify-content-left align-items-top"
      [formGroup]="contactUsForm"
      (ngSubmit)="submit()"
    >
      <label for="firstName" class="caption-primary-color">First name <span class="danger">*</span></label>
      <input
        type="text"
        id="firstName"
        formControlName="firstName"
        placeholder="Ex. Jane"
      />
      <div
        *ngIf="
          contactUsForm.get('firstName').invalid &&
          contactUsForm.get('firstName').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('firstName').invalid &&
            contactUsForm.get('firstName').touched
          "
         class="danger"
        >
          *First name is required</small
        >
      </div>

      <label for="lastName" class="caption-primary-color">Last name <span class="danger">*</span></label>
      <input type="text" formControlName="lastName" placeholder="Ex. Tailor" />
      <div
        *ngIf="
          contactUsForm.get('lastName').invalid &&
          contactUsForm.get('lastName').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('lastName').invalid &&
            contactUsForm.get('lastName').touched
          "
         class="danger"
        >
          *Last name is required</small
        >
      </div>
      <label for="email" class="caption-primary-color">Mobile Number <span class="danger">*</span></label>
      <input type="tel" formControlName="mobile" placeholder="08012345678"  [maxLength]="15"/>
      <div
        *ngIf="
          contactUsForm.get('mobile').invalid &&
          contactUsForm.get('mobile').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('mobile').invalid &&
            contactUsForm.get('mobile').touched
          "
         class="danger"
        >
          *Mobile is required</small
        >
      </div>

      <label for="email" class="caption-primary-color">Email <span class="danger">*</span></label>
      <input
        type="email"
        formControlName="email"
        placeholder="example@mail.com"
        required="required"
      />
      <div
        *ngIf="
          contactUsForm.get('email').invalid &&
          contactUsForm.get('email').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('email').invalid &&
            contactUsForm.get('email').touched
          "
         class="danger"
        >
          *Your email is required</small
        >
      </div>

      <label for="Subject" class="caption-primary-color">Subject <span class="danger">*</span></label>
      <input type="text" formControlName="subject" placeholder="Help on..." />
      <div
        *ngIf="
          contactUsForm.get('subject').invalid &&
          contactUsForm.get('subject').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('subject').invalid &&
            contactUsForm.get('subject').touched
          "
         class="danger"
        >
          *Subject is required</small
        >
      </div>

      <label for="tellUsMore">Message <span class="danger">*</span></label>

      <textarea
        formControlName="message"
        id="tellUsMore"
        cols="30"
        rows="8"
        placeholder="Leave a message"
      ></textarea>
      <div
        *ngIf="
          contactUsForm.get('message').invalid &&
          contactUsForm.get('message').touched
        "
      >
        <small
          *ngIf="
            contactUsForm.get('message').invalid &&
            contactUsForm.get('message').touched
          "
         class="danger"
        >
          *Message is required</small
        >
      </div>
      <input type="submit" value="Submit a request" />
    </form>
  </div>

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
